export default __webpack_public_path__ + "media/images/nearbyPlaces/vending_machine-ca3a8f72e2498e07fe35bebc906fc2ac.png";